import React from 'react';
import { withFormsy } from 'formsy-react';
import classNames from 'classnames';
import { FormControl, Row } from 'react-bootstrap';

class MyInput extends React.Component {

    handleChange(val) {
        this.props.setValue(val);
        if (this.props.onChange) {
            this.props.onChange(val);
        }
    }

    render() {
        const {props: P} = this;

        const errorMessage = P.errorMessage;
        const show_error = !P.isValid && (!P.isPristine || P.isFormSubmitted);
        const possibleProps = ['min', 'max', 'step', 'disabled'];
        let passDownProps = {};

        possibleProps.forEach( key => {
            if (Object.keys(P).includes(key)) {
                passDownProps[key] = P[key];
            }
        });

        return <Row className={'mb-2'}>
            <label htmlFor={P.name} className={
                classNames({
                    'col-form-label': true,
                    'col-sm-4': true,
                    'text-danger': Boolean(!P.isValid)
                })}>
                {P.label}
                {P.required ?
                    <span className={'required-symbol'}> *</span> : null
                }
            </label>
            <div className={'col-sm-8'}>
                <FormControl
                    id={P.id}
                    onChange={e => this.handleChange(e.target.value)}
                    type={P.type || 'text'}
                    value={P.value || ''}
                    {...passDownProps}
                />
                { show_error ?
                    <span
                        className={'invalid-feedback'}
                        style={{display: 'block'}}
                    >
                        { errorMessage }
                    </span> : null
                }
            </div>
        </Row>;
    }
}

MyInput.propTypes = {};
MyInput.defaultProps = {};

export default withFormsy(MyInput);
